import styled, { css } from 'styled-components';

interface TextProps {
    /** Secondary text colour, for hints and side information. */
    secondary?: boolean;
    /** The accent colour that marks something to notice. */
    accent?: boolean;
    /** The small font size. */
    small?: boolean;
    /** The medium font weight. */
    medium?: boolean;
    /** Keeps the text on one line. */
    nowrap?: boolean;
    /** Digits of equal width, for ids and amounts. */
    tabular?: boolean;
    /** Shows the pointer, for text that acts as a label for a control. */
    clickable?: boolean;
}

/** A run of text with the common variants, rendered as a span unless given another tag through `as`. */
const Text = styled.span<TextProps>`
    margin: 0;
    ${props =>
        props.secondary &&
        css`
            color: ${props.theme.colors.text.secondary};
        `}
    ${props =>
        props.accent &&
        css`
            color: ${props.theme.colors.otherAccent3};
        `}
    ${props =>
        props.small &&
        css`
            font-size: ${props.theme.text.size.small};
        `}
    ${props =>
        props.medium &&
        css`
            font-family: ${props.theme.text.font.medium};
        `}
    ${props => props.nowrap && 'white-space: nowrap;'}
    ${props => props.tabular && 'font-variant-numeric: tabular-nums;'}
    ${props => props.clickable && 'cursor: pointer;'}
`;

export default Text;
